// extracted by mini-css-extract-plugin
module.exports = {"title":"ContactPanel-module--title--2GqOz","content":"ContactPanel-module--content--3ExgB"};